import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

// B1 — reînnoire transparentă a sesiunii: la un 401 pe o cerere autentificată,
// încercăm O SINGURĂ dată `POST /auth/refresh` (folosește cookie-ul refresh_token,
// valabil 30 zile) și reluăm cererea. Fără buclă: nu re-încercăm refresh-ul însuși
// și marcăm cererea cu `_retried`. Dacă și refresh dă 401, lăsăm eroarea să curgă
// (AuthContext / paginile tratează delogarea).
let _refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const original = error?.config;
    const status = error?.response?.status;
    const url = original?.url || "";
    const isAuthFlow = url.includes("/auth/refresh") || url.includes("/auth/login") || url.includes("/auth/me");
    if (status === 401 && original && !original._retried && !isAuthFlow) {
      original._retried = true;
      try {
        _refreshing = _refreshing || api.post("/auth/refresh");
        await _refreshing;
        _refreshing = null;
        return api(original);
      } catch (e) {
        _refreshing = null;
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (!detail) return err?.message || "A apărut o eroare.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail.map((d) => (d?.msg ? d.msg : JSON.stringify(d))).join(" ");
  }
  if (detail?.msg) return detail.msg;
  return String(detail);
}

export default api;
